const initialState = {
  // Reviews for the vendor currently being viewed.
  vendorId: null,
  items: [],
  total: 0,
  average: 0,
  count: 0,
  loading: false,
  // Aggregate summaries keyed by vendorUserId (distribution included).
  summaries: {},
  // Matched vendors for the last created request (popup).
  matchedVendors: { items: [], total: 0, loading: false },
  // Consolidated responses for a request.
  allResponses: { requestId: null, items: [], totalCount: 0, loading: false },
};

const reviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'VENDOR_REVIEWS_LOADING':
      return { ...state, loading: action.payload };
    case 'VENDOR_REVIEWS': {
      const { vendorUserId, items, total, average, count } = action.payload;
      return { ...state, vendorId: vendorUserId, items, total, average, count, loading: false };
    }
    case 'VENDOR_REVIEW_SUMMARY': {
      const { vendorUserId, ...summary } = action.payload;
      return { ...state, summaries: { ...state.summaries, [vendorUserId]: summary } };
    }
    case 'MATCHED_VENDORS_LOADING':
      return { ...state, matchedVendors: { ...state.matchedVendors, loading: action.payload } };
    case 'MATCHED_VENDORS':
      return {
        ...state,
        matchedVendors: { items: action.payload.items, total: action.payload.total, loading: false },
      };
    case 'ALL_RESPONSES_LOADING':
      return { ...state, allResponses: { ...state.allResponses, loading: action.payload } };
    case 'ALL_RESPONSES':
      return {
        ...state,
        allResponses: {
          requestId: action.payload.requestId,
          items: action.payload.items,
          totalCount: action.payload.totalCount,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default reviewsReducer;
